import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import api from "../../lib/api";

/**
 * EnquiriesTicker — subtle social-proof pill showing weekly enquiry count.
 * Fetches a privacy-safe count from a public backend endpoint. Silently
 * renders nothing on network error so it never blocks the page.
 */
export default function EnquiriesTicker({ className = "" }) {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let alive = true;
    api
      .get("/leads/enquiries-count")
      .then((r) => {
        if (alive) setCount(r.data?.this_week ?? null);
      })
      .catch(() => {});
    return () => {
      alive = false;
    };
  }, []);

  if (!count) return null;

  return (
    <div
      data-testid="enquiries-ticker"
      className={`inline-flex items-center gap-2 rounded-full bg-white/80 backdrop-blur px-3 py-1.5 text-xs text-brand-ink2 border border-brand-cream shadow-sm ${className}`}
    >
      <span className="relative flex h-2 w-2">
        <span className="absolute inline-flex h-full w-full rounded-full bg-brand-terracotta opacity-70 animate-ping" />
        <span className="relative inline-flex rounded-full h-2 w-2 bg-brand-terracotta" />
      </span>
      <Activity size={12} className="text-brand-olive" />
      <span>
        <span className="font-semibold text-brand-ink">{count}</span> patients enquired this week
      </span>
    </div>
  );
}
